<template>
  <div class="Bgc-white">
    <Header />
    <div class="container padding-custom">
      <div class="row">
        <div class="col-12">
          <h2 class="mb-5">{{$t('language.posadasCorporate.moviemientosDia.movimientosDelDia')}}</h2>
          <Loader v-if="enableLoader"/>
          <b-table v-if="!enableLoader"
            show-empty
            striped
            responsive
            :fields="changeFields == 'es' ? fields : fields2"
            :items="items"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="changeText"
          >
            <template slot="[confirm]" slot-scope="data" v-html="data.value"></template>
            <span slot="[options]" slot-scope="data" v-html="data.value"></span>

            <template v-slot:cell(confirm)="row">
              <span
                class="link cursor-pointer"
                @click.prevent="callReservationByCode(row.value)"
              >{{ row.value}}</span>
            </template>
            <template v-slot:cell(options)="row">
                <span v-if="row.value.editing" @click="sendNoCon(row,row.value);callReservationByCode(row.item.confirm); flagE=true" class="link cursor-pointer">
                  <i v-b-popover.hover.top="$t('language.posadasCorporate.moviemientosDia.toltipIcons.modificar')" class="icon-avanzada icon-edit"></i>
                </span>
             
              <i v-if="row.value.copying" @click="buscarReservaByCode(row); deleteSupple()" v-b-popover.hover.top="$t('language.posadasCorporate.moviemientosDia.toltipIcons.duplicar')" class="icon-avanzada icon-doc-copy link cursor-pointer"></i>


        
              <span
                @click="cancelCode = row.item.confirm; reservationStatus = row.item.status;modalReenvioReservacion(row.item)"
                class="link cursor-pointer"
                v-if="row.value.emailing"
              >
                <i v-b-popover.hover.top="$t('language.posadasCorporate.moviemientosDia.toltipIcons.compartirCorreo')" class="icon-avanzada icon-mail"></i>
              </span>
        


              <span v-if="row.value.deleting" class="link cursor-pointer">
                <i v-if="row.value.deleting" @click="sendConfir(row.item.confirm)" v-b-popover.hover.top="$t('language.posadasCorporate.moviemientosDia.toltipIcons.eliminar')" class="icon-avanzada icon-trash" style="cursor: pointer"></i>
              </span>
              <span
                @click="modalorma(row.item)"
                class="link cursor-pointer"
                v-if="row.value.sending"
              >
                <i v-b-popover.hover.top="$t('language.posadasCorporate.moviemientosDia.toltipIcons.envioProforma')" class="icon-avanzada icon-report-send" @click.prevent="$bvModal.show('reenviarProforma')"
                v-if="row.value.sending"></i>
              </span>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            align="right"
            size="sm"
          ></b-pagination>
        </div>
      </div>
    </div>
      <DetalleCostos v-if="banDetCost" :key="componentKey"></DetalleCostos>

    <!-- Modal reenviar confirmación -->
    <modal v-if="banModalReenvioConfirmacion" @close="cancelSendEmailConfirmacion" maxWidth="max-w-500 w-100">
      <template slot="header">
        <p class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.reenvioConfirmacionEmail')}}</p>
      </template>
      <template slot="body">
        <div class="w-100 align-top">
          <div class="row">
            <div class="col-12">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.datosReservacion')}}</span>
            </div>

            <div class="col-6">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.numeroConfirmacion')}}:</span>
            </div>
            <div class="col-6">
              <span>{{dataReenviarConfirmacionReservacion.confirm}}</span>
            </div>

            <div class="col-6">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.nombreHuesped')}}:</span>
            </div>
            <div class="col-6">
              <span>{{dataReenviarConfirmacionReservacion.name}}</span>
            </div>

            <div class="col-6">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.hotel')}}:</span>
            </div>
            <div class="col-6">
              <span>{{dataReenviarConfirmacionReservacion.hotel}}</span>
            </div>

            <div class="col-6">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.entrada')}}:</span>
            </div>
            <div class="col-6">
              <span>{{dataReenviarConfirmacionReservacion.into}}</span>
            </div>

            <div class="col-6">
              <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.salida')}}:</span>
            </div>
            <div class="col-6">
              <span>{{dataReenviarConfirmacionReservacion.out}}</span>
            </div>
          </div>
          <hr />
          <div class="w-100 align-top">
            <div class="row">
              <div class="col-12">
                <p>{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.text1')}}:</p>
              </div>
              <div class="col-12 mb-2">
                <label class="PC-text--semibold w-100">
                  {{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.email')}} 1
                  <input v-model="emailConfirmacionUno" :class="{ 'is-invalid': (!$v.emailConfirmacionUno.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                  <span class="notas" v-if="!$v.emailConfirmacionUno.email">
                    {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                  </span>
                </label>
              </div>
              <div class="col-12 mb-2">
                <label class="PC-text--semibold w-100">
                  {{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.email')}} 2
                  <input v-model="emailConfirmacionDos" :class="{ 'is-invalid': (!$v.emailConfirmacionDos.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                  <span class="notas" v-if="!$v.emailConfirmacionDos.email">
                    {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                  </span>
                </label>
              </div>
              <div class="col-12">
                <label class="PC-text--semibold w-100">
                  {{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.email')}} 3
                  <input v-model="emailConfirmacionTres" :class="{ 'is-invalid': (!$v.emailConfirmacionTres.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                  <span class="notas" v-if="!$v.emailConfirmacionTres.email">
                    {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <Loader v-if="banLoaderReenvioConfirmacion"/>
      </template>
      <template slot="footer">
        <button class="secondary-button" @click="cancelSendEmailConfirmacion">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.cancelar')}}</button>
        <button :disabled="!isDisabledConfirmacion || banLoaderReenvioConfirmacion" @click="sendRightEmail">{{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.enviar')}}</button>
      </template>
    </modal>

<!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
   <modal v-show="isModalNoTarifas" @close="closeModalNoTarifas" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{$t('language.posadasCorporate.modales.noResults.title')}}</b>
      </template>
      <template slot="body">

        <p class="Ta-left">
          {{paragraph1}}<br><br>{{paragraph2}}
        </p>



      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos" @click="closeModalNoTarifas"
          aria-label="Close modal">
           {{$t('language.posadasCorporate.modales.noResults.ok')}}

        </button>
      </template>
    </modal>
<!-- TERMINA MODAL NO PUBLICAS Y NO NEGOCIADAS -->



    <!-- Modal reenviar proforma -->
    <b-modal v-if="banModalReenvioProforma" id="reenviarProforma" footer-class="extra-light" hide-header hide-footer>
      <p class="text-right">
        <button class="PC-btn--closeModal" @click="cancelSendEmailProforma">
          <i class="icon-Cerrar icon-close-rounded-outline"></i>
        </button>
      </p>
      <p class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.reenviarProformaEmail')}}</p>
      <div role="tablist">
        <b-card class="mb-1 PC-card--collapsible">
          <b-card-body>
            <div class="w-100 align-top">
              <div class="row">
                <div class="col-6">
                  <span class="PC-text--semibold">{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.numeroConfirmacion')}}:</span>
                </div>
                <div class="col-6">
                  <span>{{dataEnviarEmailProforma.confirm}}</span>
                </div>
              </div>
              <hr />
              <div class="w-100 align-top">
                <div class="row">
                  <div class="col-12">
                    <p>{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.text1')}}:</p>
                  </div>
                  <div class="col-12 mb-2">
                    <label class="PC-text--semibold w-100">
                      {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.correoElectronico')}} 1
                      <input v-model="emailProformaUno" :class="{ 'is-invalid': (!$v.emailProformaUno.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                      <span class="notas" v-if="!$v.emailProformaUno.email">
                        {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                      </span>
                    </label>
                  </div>
                  <div class="col-12 mb-2">
                    <label class="PC-text--semibold w-100">
                      {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.correoElectronico')}} 2
                      <input v-model="emailProformaDos" :class="{ 'is-invalid': (!$v.emailProformaDos.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                      <span class="notas" v-if="!$v.emailProformaDos.email">
                        {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                      </span>
                    </label>
                  </div>
                  <div class="col-12">
                    <label class="PC-text--semibold w-100">
                      {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.correoElectronico')}} 3
                      <input v-model="emailProformaTres" :class="{ 'is-invalid': (!$v.emailProformaTres.email)}" class="form-control" type="email" :placeholder="$t('language.posadasCorporate.moviemientosDia.reenvioProforma.ejemplo') + '@' + $t('language.posadasCorporate.moviemientosDia.reenvioProforma.correo') + '.com'" />
                      <span class="notas" v-if="!$v.emailProformaTres.email">
                        {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.emailNoValido')}}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <Loader v-if="banLoaderReenvioProforma"/>
      <div class="row">
        <div class="col-12 col-md-6 mt-2">
          <button class="secondary-button" @click="cancelSendEmailProforma">{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.cancelar')}}</button>
        </div>
        <div class="col-12 col-md-6 mt-2">
          <button :disabled="!isDisabledProforma|| banLoaderReenvioProforma" @click="sendEmailProforma">{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.enviar')}}</button>
        </div>
      </div>
    </b-modal>

    <!-- Modal confirmación -->
    <modal v-show="isModalConfirmacion" @close="closeModalConfirmacion" maxWidth="max-w-500">
      <template slot="header">
        <b v-if="!speSpa" class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.moviemientosDia.reenvioConfirmacion.confirmacionReenviadaExito')}}
        </b>
        <b v-if="speSpa" class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.moviemientosDia.speTitle')}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{textModalExitoEnvioEmail}}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalConfirmacion"
          aria-label="Close modal"
        >{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.entendido')}}</button>
      </template>
    </modal>

    <!-- Modal Proforma -->
    <modal v-show="isModalProforma" @close="closeModalProforma" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.confirmacionReenviadaExito')}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{textModalExito}}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalProforma"
          aria-label="Close modal"
        >{{$t('language.posadasCorporate.moviemientosDia.reenvioProforma.entendido')}}</button>
      </template>
    </modal>

    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.expiredSession.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t('language.posadasCorporate.modales.expiredSession.body') }}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary"
          @click="closeExpiredModal"
          aria-label="Close modal"
        >{{ $t('language.posadasCorporate.modales.expiredSession.button') }}</button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

    <modal v-if="isModalConsiEspecial" @close="closeModalConsiEspecial" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ titleConsiEspecial }}</b>
      </template>
      <template slot="body">
        
        <div v-if="!mojito">
          <p class="Ta-left">
            {{bodyConsiEspecial}}
          </p>
        </div>

        <div v-if="mojito">
          <p v-for="(conEsp, index) in bodyConsiEspecial" :key="index" class="Ta-left">
            {{conEsp}}
          </p>
        </div>

      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="closeModalConsiEspecial" aria-label="Close modal">
          {{$t('language.posadasCorporate.reservacionesRegistro.continuar')}}
        </button>
      </template>
    </modal>

    <Footer />
  </div>
</template>
<script>

import * as GlobalServices from "../../../utils/GlobalServices";
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import Header from "../../generales/Header.vue";
import Footer from "../../generales/Footer.vue";
import Mixin from "../../../mixins/commons.js";
import axios from "axios";
import DetalleCostos from "./../DetalleCostos";
import Modal from "./../../addons/Modal.vue";
import SecureLS from "secure-ls";
import i18n from "../../../plugins/i18n";
import Loader from "../../loader/Loader";
import { required, email} from "vuelidate/lib/validators";

export default {
  name: "BusquedaPorTarifa",
  components: {
    Header,
    Footer,
    DetalleCostos,
    Modal,
    Loader
  },
  mixins: [Mixin],
  mounted() {
    if (!GlobalFunctions.validIfGenericUser()) {
      this.dataTable();
    }
  },
  data() {
    return {
      pyp: 'PYP', //no cambiar este valor
      pypsa: 'PYPSA', //no cambiar este valor
      tipoClienteID: '',
      tipoTarifa: 0,
      speSpa: false,
      ratePolicy: [],
      allowDetailCost: true,
      cancelCode : "",
      reservationStatus: "",
      mojito: false,
      titleConsiEspecial: '',
      textModalExitoEnvioEmail: '',
      direccionConsiEspe: '',
      isModalConsiEspecial: false,
      bodyConsiEspecial: '',
      tabActive: 1,
      flagE: false,
      hideAll: false,
      isModalNoTarifas: false,
      paragraph1: "",
      paragraph2: "",
      banLoaderReenvioConfirmacion: false,
      banModalReenvioConfirmacion: false,
      enableLoader: false,
      textModalExito: '',
      banModalReenvioProforma: false,
      dataEnviarEmailProforma: null,
      dataReenviarConfirmacionReservacion: null,
      banLoaderReenvioProforma: false,
        datosHabHotModalCosto: {
        habitacion: null,
        hotel: null,
        localStor: null,
        userClientID: false,
        tabActive: null
      },
      componentKey: 0,
      banDetCost: false,
      isExpiredModalVisible: false,
      ls: new SecureLS({ encodingType: "aes" }),
      perPage: 7,
      currentPage: 1,
      fields: [
        {
          key: "confirm",
          stickyColumn: true,
          label: "Núm. confirmación"
        },
        {
          key: "status",
          label: "Estatus"
        },
        {
          key: "name",
          label: "Huésped"
        },
        {
          key: "hotel",
          label: "Hotel"
        },
        {
          key: "into",
          label: "Entrada"
        },
        {
          key: "out",
          label: "Salida"
        },
        {
          key: "options",
          label: "Opciones"
        }
      ],
      fields2: [
        {
          key: "confirm",
          stickyColumn: true,
          label: "Confirmation number"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "name",
          label: "Guest"
        },
        {
          key: "hotel",
          label: "Hotel"
        },
        {
          key: "into",
          label: "Check in"
        },
        {
          key: "out",
          label: "Check out"
        },
        {
          key: "options",
          label: "Options"
        }
      ],
      items: [],
      isModalConfirmacion: false,
      isModalProforma: false,
      emailConfirmacionUno: '',
      emailConfirmacionDos: '',
      emailConfirmacionTres: '',
      emailProformaUno: '',
      emailProformaDos: '',
      emailProformaTres: ''
    };
  },
  validations: {
    emailConfirmacionUno: {
      required,
      email,
    },
    emailConfirmacionDos: {
      required,
      email,
    },
    emailConfirmacionTres: {
      required,
      email,
    },
    emailProformaUno: {
      required,
      email,
    },
    emailProformaDos: {
      required,
      email,
    },
    emailProformaTres: {
      required,
      email,
    },
  },
  computed: {
    changeText() {
        if(this.$store.getters.gettingLang == "es") {
          return "No hay registros para mostrar"
        } else {
          return "There are no records to show"
        }
    },
    changeFields() {
        return this.$store.getters.gettingLang
    },
    rows() {
      return this.items.length;
    },
    isDisabledConfirmacion() {
      return this.$v.emailConfirmacionUno.email && this.$v.emailConfirmacionDos.email && this.$v.emailConfirmacionTres.email && (this.emailConfirmacionUno.length > 6 || this.emailConfirmacionDos.length > 6 || this.emailConfirmacionTres.length > 6);
    },
    isDisabledProforma() {
        return this.$v.emailProformaUno.email && this.$v.emailProformaDos.email && this.$v.emailProformaTres.email && (this.emailProformaUno.length > 6 || this.emailProformaDos.length > 6 || this.emailProformaTres.length > 6);
      },
    numIsma() {
      return this.$store.getters.gettingConfirmationNumberForIsma
    }
  },
  created() {
    this.tipoClienteID = this.ls.get('ClientId').data;
    if (!GlobalFunctions.validIfGenericUser()) {
      this.ls.set('knowOrigin', false)
      this.ls.set('roomNameSW', "")
    }
  },
  methods: {
      deleteSupple() {
            this.$store.commit("updateTotalStayII", [])
            this.$store.commit("updateTotalStay", [])
this.ls.set('generalUp', false)
this.ls.set('supleCondi', null)
this.ls.set('supleCondiOneFirstNight', null)
this.ls.set('totalSupplements', null)
this.ls.set('totalSupplementsTax', null) 
this.ls.set('moreStayingTaxes', null)

       },
      
    getRoomImagen(response){
        let roomImagen = '';
        let roomCode = response.roomCode;
        let roomCodes = response.hotelDetailResponse.roomDetailResponseList;
        roomCodes.forEach(function(value){
          if(value.roomCode === roomCode){
            roomImagen =   value.roomName;
          }else {
            roomImagen = "";
          }
        });
        return roomImagen;
      },
     getHabitaciones(response){
        let habitaciones = '';
        let data1 = '';
        let data2 = '';
        let roomCode = response.roomCode;
        let roomCodes = response.hotelDetailResponse.roomDetailResponseList;
        roomCodes.forEach(function(value){
          habitaciones = "";
          if(value.roomCode === roomCode){
            data1 = value.roomName;
          }else {
            data2 = i18n.t('language.posadasCorporate.reservacionCancelacion.noEncontrado');
          }
        });

        if(data1 !== ''){
          habitaciones = data1;
        }else{
          habitaciones = data2;
        }

        return habitaciones;
      },
        ifNull(data){
        if(data === null){
          return "";
        }
        return data;
      },
     setDataEmail(byCode){
        let ls = new SecureLS({encodingType: 'aes'});
        var a = '';
        a = this.ls.get('Token');
        let profile = this.ls.get("Profile").data;
        let hotelDetail = this.ls.get("HotelDetailData").data.data.response;
        let politicas = this.ls.get("HotelDetailDataPoliticas");
        var ban = false;
        if (hotelDetail.hotelDetailResponse.specialMessage.length > 0) {
          ban = true;
        }

        let benefist = '';
        let restrictions = '';
        if(hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList.length >= 1){
          benefist = hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].benefits;
          restrictions = hotelDetail.hotelDetailResponse.ratePolicyInfoResponseList[0].restrictions;
        }
      var listTemCorreos = []
        if (this.emailConfirmacionUno !== '') {
        listTemCorreos.push(this.emailConfirmacionUno);
      }
      if (this.emailConfirmacionDos !== '') {
        listTemCorreos.push(this.emailConfirmacionDos);
      }
      if (this.emailConfirmacionTres !== '') {
        listTemCorreos.push(this.emailConfirmacionTres);
      }
     var rateOptionalSupplementResponseList = []
        if(byCode.rateOptionalSupplementResponseList != null && byCode.rateOptionalSupplementResponseList.length != 0) {
              rateOptionalSupplementResponseList = byCode.rateOptionalSupplementResponseList
              }
              
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI+process.env.VUE_APP_CM, {
          email                  : listTemCorreos,
          reservationNumber      : this.cancelCode,
          cancelationNumber      : byCode.cancelationNumber,
          reservationStatusCode  : "01",    
          hotelCode              : byCode.hotelCode,
          hotelName              : byCode.hotelName,
          benefits               : benefist,
          restrictions : restrictions,
          servicesTable : "servicesTable",
          rateTypeCode : hotelDetail.roomContractTypeCode,
          contractCode : hotelDetail.roomContractCode,
          numRooms : hotelDetail.totalRooms,
          amenityList : hotelDetail.hotelDetailResponse.amenityList,
          ratesResponse : hotelDetail.ratesResponse,
          showRates: ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showRates),
          showPublicRates : ((this.tipoClienteID==this.pyp||this.tipoClienteID==this.pypsa)&&this.tipoTarifa==1?false:profile.ratesPermissionsResponse.showPublicRates),
          supplementDescription : this.ifNull(hotelDetail.supplementResponse),
          roomName : this.getHabitaciones(hotelDetail),
          roomCode : hotelDetail.roomCode,
          mainGuestName : hotelDetail.name,
          mainMiddleName : "",
          mainGuestLastName : hotelDetail.fatherSurname,
          mainGuestMotherMaidenName : hotelDetail.motherSurname,
          companionGuestName              : hotelDetail.companionName,
          companionGuestLastName          : hotelDetail.companionFatherSurname,
          companionGuestMotherMaidenName  : hotelDetail.companionMotherSurname,
          todayDate     : new Date().toISOString().slice(0, 10),
          arrivalDate   : hotelDetail.arrivalDate,
          departureDate : hotelDetail.departureDate,
          currencyCode  : hotelDetail.currencyCode,
          totalAdults   : hotelDetail.totalAdults,
          totalChildren : hotelDetail.totalChildren,
          totalInfants  : hotelDetail.totalInfants,
          hotelAddress  : hotelDetail.hotelDetailResponse.hotelAddress,
          promotion     : hotelDetail.roomContractTextName,
          supplements : "supplements",
          specialRequirements : hotelDetail.requirementTypeResponse,
          penalty : "",
          groupName           : "",
          groupType           : "",
          policyDescription   : hotelDetail.travelPolicy,
          brand               : hotelDetail.brandName,
          brandImage          : hotelDetail.hotelDetailResponse.brandImage,
          guestTitle          : "",
          dueDate             : new Date().toISOString().slice(0, 10),
          paymentType         : hotelDetail.paymentResponse.paymentMethod,
          voucherResponse     : hotelDetail.paymentResponse.voucher,
          creditCardResponse  : hotelDetail.paymentResponse.creditCard,
          apreciareNumber : hotelDetail.apreciareClubNumber,
          fiestaRewardsNumber : hotelDetail.fiestaRewardsNumber,
          motivaNumber : hotelDetail.motivaNumber,
          employeeNumber : hotelDetail.employeeNumber,
          nights : hotelDetail.numberOfNights,
          coupon : this.ifNull(hotelDetail.couponNumber),
          phone : hotelDetail.hotelDetailResponse.hotelPhone,
          rateType : hotelDetail.roomContractTypeName,
          guarantee : "guarantee",
          guaranteeType: "guaranteeType",
          dailyCost         : hotelDetail.ratesResponse.totalCostWithoutTaxes,
          totalPerNight     : hotelDetail.ratesResponse.ratesDetailResponseList[0].roomCostWithTaxes,
          totalSupplements  : hotelDetail.ratesResponse.totalSupplements,
          totalTaxes        : hotelDetail.ratesResponse.totalTaxes,
          totalCost         : hotelDetail.ratesResponse.totalCostWithTaxes,
          hotelImage : hotelDetail.hotelDetailResponse.hotelMailImage,
          roomImage :  this.getRoomImagen(hotelDetail),
          mapImage : "",
          reasonTrip : "2",
          discountCode : hotelDetail.discountCode,
          socialReasonResponse : hotelDetail.socialReasonResponse,
          ratePolicyElementResponseList : this.ratePolicy.ratePolicyElementResponseList,
          sendSpecialConsiderations: ban,
          rateOptionalSupplementList: rateOptionalSupplementResponseList
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.ls.get('Token').data,
                  'Accept-language': this.ls.get('Language').data,
            'Content-Type' : 'application/json'
          }
        })
          .then(res => {

            let resObject = JSON.parse(JSON.stringify(res));
            let response = resObject.data.response;
            if ( resObject.status === 200 || resObject.status === 201) {
              if(this.$store.getters.gettingLang == "es") {
                  this.textModalExitoEnvioEmail = "Tu confirmación de la cancelación ha sido reenviada a los correos electrónicos ingresados."
              } else {
                  this.textModalExitoEnvioEmail = "The canceled reservation has been sent to the captured e-mails."
              }
              this.ratePolicy = resObject.data.response;
              this.banLoaderReenvioConfirmacion = false
              this.banModalReenvioConfirmacion = false
              this.isModalConfirmacion = true
            } 
          })
          .catch(error=>{
            this.banLoaderReenvioConfirmacion = false
   let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  
  this.$router.push({ name: "Error" });
  
 
}
          });
      },
       getDate(fecha){
        let date = '';
        let ls = new SecureLS({encodingType: 'aes'});
        var language = this.ls.get('Language');
        if(language.data === 'en'){
          date = fecha.split("/");
          date = date[1]+"/"+date[0]+"/"+date[2];
        }else {
          date = fecha;
        }
        return date;
      },
    getPoliticasTarifas(byCode){
        let ls = new SecureLS({encodingType: 'aes'});
        const profile = this.ls.get('Profile').data;
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RP, {
          hotelCode: byCode.hotelCode,
          arrivalDate:this.getDate(byCode.arrivalDate),
          departureDate:this.getDate(byCode.departureDate),
          contractCode: byCode.roomContractCode,
          contractType: byCode.roomContractTypeCode,
          currencyCode: byCode.currencyCode,
          showRates: profile.ratesPermissionsResponse.showRates,
          showPublicRates: profile.ratesPermissionsResponse.showPublicRates,
          hasCombinedRate: false,
          dailyRate: byCode.ratesResponse.ratesDetailResponseList[0].roomCostWithTaxes,
          totalRate:Number(byCode.ratesResponse.totalCost)
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer '+ this.ls.get('Token').data,
                  'Accept-language': this.ls.get('Language').data,
            'Content-Type' : 'application/json'
          }
        })
          .then(res => {
            this.ratePolicy = [];
            let resObject = JSON.parse(JSON.stringify(res));
            let response = resObject.data.response;
            if ( resObject.status === 200 || resObject.status === 201) {
              this.ratePolicy = resObject.data.response;
              this.ls.set('HotelDetailDataPoliticas', {data: resObject.data});
              this.setDataEmail(byCode)
            }
          })
          .catch(error=>{
      this.banLoaderReenvioConfirmacion = false

            // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
          })
      },
    closeModalConsiEspecial(){
      this.isModalConsiEspecial = false;
      setTimeout(() => {
        switch (this.direccionConsiEspe) {
          case 'modificacion':
            this.$router.push({ name: "ReservacionesModificacion" });
            break;
          case 'copia':
            this.$store.commit('changePersistRegistryData', true)
            this.$router.push({ name: "ReservacionesRegistro" });
            break;
        }
      }, 10);
    },
     codeDetailing() {

// Consultar detalle de hotel
var ls = new SecureLS({encodingType: 'aes'});
ls.set('mesContractCodesForReservation', {data: this.contractCodes})
ls.set('brandCodeForReservationService', {data: this.brandCode})

// When I send hotelDetail request in Spanish
if(this.$store.getters.gettingLang == "es") {
  var dateInHotelDetail = this.beautyDateInput;
  var dateOutHotelDetail = this.beautyDateOutput;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[1] + '-' + datearray[0];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[1] + '-' + datearray2[0];

} else {    // When I send hotelDetail request in Spanish
  var dateInHotelDetail = this.beautyDateInput;
  var dateOutHotelDetail = this.beautyDateOutput;
  var datearray = dateInHotelDetail.split("/");
  var datearray2 = dateOutHotelDetail.split("/");
  var newdateHotelDetail = datearray[2] + '-' + datearray[0] + '-' + datearray[1];
  var newdate2HotelDetail = datearray2[2] + '-' + datearray2[0] + '-' + datearray2[1];

}
this.contractCodes.push(this.descuento)
                var a =    this.contractCodes.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);

axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
  brandCode: this.brandCode,
	hotelCode: this.codeHotel,
  contractCodes: a,
  checkInDate: newdateHotelDetail,
	checkOutDate: newdate2HotelDetail

}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + this.token,
                'Content-Type' : 'application/json',
                'Accept-Language' : this.language.data
                }
       })
.then(res => {
this.flag = false
       var resObject=JSON.parse(JSON.stringify(res));
       if ( resObject.status == 200 || resObject.status == 201) {
       var ls = new SecureLS({encodingType: 'aes'});
       ls.set('DetailHotelInfo', {data: resObject.data});
      var codeProm = '';
      if (this.descuento != '') {
        codeProm = this.descuento
      }
      if (this.promocion != '' && this.promocion === 'BUSINESS') {
        codeProm = 'CCR114'
      }
       for(var iterator = 0; iterator < resObject.data.response.ratePolicyInfoResponseList.length; iterator++) {
         if(codeProm == resObject.data.response.ratePolicyInfoResponseList[iterator].contractCode) {
           ls.set('rateNameDiscountCode',  resObject.data.response.ratePolicyInfoResponseList[iterator].rateName);
         }
       }
       this.enableLoader= false
// ouiLesG
        this.isModalNoTarifas = false
        this.isModalTarifas = false
      this.noMoreTwoDays = true
                 this.$store.commit('hotelInfoIsSet');
                 this.$store.commit('reloadCostDetail')
        ls.set("choosingEditing", false)

       this.$router.push({ name: 'BusquedaPorTarifa'})
this.$store.commit('firstChange', {enable: true})
                  if(this.moreThanMounted == true && (this.responseSpecialMessageForDiscounts != '' || this.responseSpecialMessageForDiscounts != null || this.responseSpecialMessageForDiscounts != 'N/A')) {
    this.copyMounted()
  }

   }
   if(resObject.status == 404) {
             this.isModalTarifas = false
          this.isModalNoTarifas = false
   }
   if(resObject.status == 401) {
             this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
   }
         })
    .catch(error=>{
       this.enableLoader= false
let errorObject=JSON.parse(JSON.stringify(error));
   
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
  
 
}
 
if (errorObject.message == 'Request failed with status code 401') {
          this.isModalNoTarifas = false
          this.isModalTarifas = false
   this.clearLocalStorage()
} else {}
})
// Finir Consultation d'hotel
    },
     closeModalNoTarifas() {
        this.isModalNoTarifas = false
        this.$router.push({ name: 'Reservaciones'})

      },
    sendConfir(numConfirm) {
      this.$store.commit('confirmationNumberForIsma', {confirmationNumber: numConfirm})
      this.$router.push({ name: 'ReservacionesCancelacion'})
    },

       buscarReservaByCode(dataReservation){
         this.enableLoader = true
        const profile = this.ls.get('Profile').data;
        var data = {
          confirmationNumber: dataReservation.item.confirm,
          profileType: profile.profileType,
          hasEditCancelPermissions: true,
          fullReservationData: true
        }

        GlobalServices._hotelReservationByCode(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {

// Set roomName
                         this.ls.set('allowF', true)

            for(var i = 0; i < response.data.hotelDetailResponse.roomDetailResponseList.length; i++) {
                if(response.data.roomCode == response.data.hotelDetailResponse.roomDetailResponseList[i].roomCode) {
                      this.ls.set('roomNameSW', response.data.hotelDetailResponse.roomDetailResponseList[i].roomName)
                }             
            }
            if(this.ls.get('roomNameSW') == null || this.ls.get('roomNameSW') == "") {
                       axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_HOTEL + `/${response.data.hotelDetailResponse.hotelCode}/`
 + process.env.VUE_APP_CONFIG, {
       withCredentials: true,
      credentials: 'include',
      headers: {'Authorization': 'Bearer '+ this.ls.get('Token').data,
                  'Accept-language': this.ls.get('Language').data,
                  }
         })
          .then(res => {
 
          for(var i = 0; i <res.data.response.roomList.length; i++) {
            for(var j = 0; j < res.data.response.roomList[i].roomCodes.length; j++) {
              if(res.data.response.roomList[i].roomCodes[j] == response.data.roomCode) {
                    this.ls.set('roomNameSW',res.data.response.roomList[i].categoryName)
              }
            }
          }
             })
                  .catch(error=>{
        let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
  
 
} 
 
  }) 
            }
        // Set roomName

          if (response.status === 200) {
            var motiva = response.data.motivaNumber
            if(response.data.motivaNumber== null) {
              motiva = ""
            }
            var discount = response.data.discountCode
            if(response.data.discountCode== null) {
              discount = ""
            }
            var data1 = {

roomType: "",   // NOT USED
selectedRooms: [1],
brandCode: response.data.brandCode,
hotelName: response.data.hotelName,
beautiDateInput: response.data.arrivalDate,
beautiDateOutput: response.data.departureDate,
              hotelCode: response.data.hotelCode,
              arrivalDate: response.data.arrivalDate,
              departureDate: response.data.departureDate,
              currencyCode: response.data.currencyCode,
              totalAdults: response.data.totalAdults,
              totalChildren: response.data.totalChildren,
              totalInfants: response.data.totalInfants,
              totalRooms: response.data.totalRooms,
              agreementCode: "",
              iataCode: "",
              motivaCode: motiva,
              discountCode: discount,
              promoCode: response.data.promoCode,
              profileType: profile.profileType,
              showPublicRates: profile.ratesPermissionsResponse.showPublicRates,
              showRates: profile.ratesPermissionsResponse.showRates,
              contractCode: response.data.roomContractCode,
              roomCodeList:[response.data.roomCode]
            }
            var hotelCountry = response.data.hotelDetailResponse.hotelCountry
            var hotelCity = response.data.hotelDetailResponse.hotelCity
            var tabActive = 1
              var responseHotel = {
              response: response.data.hotelDetailResponse
            }
                           this.ls.set('brandCodeForWs', {data: response.data.brandCode})

            this.ls.set('brandNameForWs', {data: response.data.brandName})
            this.ls.set('DetailHotelInfo', {data: responseHotel});
   if(response.data.hotelDetailResponse.hotelMailImage == null) {
              this.ls.set('hotelMailImage', {data:""})

            } else {

              this.ls.set('hotelMailImage', {data:response.data.hotelDetailResponse.hotelMailImage})
            }
            // Find tabActive
            if(response.data.roomContractTypeName == "Tarifa Negociada" || response.data.roomContractTypeName == "Negotiated Rate") {
                tabActive = 1
                this.tabActive = 1
            }
            if(response.data.roomContractTypeName == "Tarifa Pública" || response.data.roomContractTypeName == "Public Rate") {
                tabActive = 2
                this.tabActive = 2

            }
            // Find tabActive

            // Get policies
            let bodyRatePolicy = {
        hotelCode: response.data.hotelCode,
        arrivalDate: response.data.arrivalDate,
        departureDate: response.data.departureDate,
        contractCode: response.data.roomContractCode,
        contractType: response.data.roomContractTypeCode,
        currencyCode: response.data.currencyCode,
        showRates: profile.ratesPermissionsResponse.showRates,
        showPublicRates: profile.ratesPermissionsResponse.showPublicRates,
        hasCombinedRate: response.data.ratesResponse.hasCombinedRates,
        dailyRate: response.data.ratesResponse.ratesDetailResponseList[0].roomCostWithoutTaxes,
        totalRate: response.data.ratesResponse.totalCostWithoutTaxes,
      };
      var  politicas = {
        listPoliticas: null,
        privacyPolicyURL: null,
      }



            // Get policies
        var data11 = {
            hotelCode: data1.hotelCode,
	arrivalDate: data1.beautiDateInput,
	departureDate: data1.beautiDateOutput,
	currencyCode: data1.currencyCode,
	totalAdults: data1.totalAdults,
	totalChildren: data1.totalChildren,
	totalInfants: data1.totalInfants,
	totalRooms: data1.totalRooms,
	agreementCode: data1.agreementCode,
	iataCode: "",
	motivaCode: data1.motivaCode,
	discountCode: data1.discountCode,
	promoCode: data1.promoCode,
	profileType: data1.profileType,
	showPublicRates: data1.showPublicRates,
	showRates: data1.showRates,
	contractCode: data1.contractCode,
	roomCodeList: data1.roomCodeList
        }
// Quand la lague change a Anglais faire ceci:

axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_RESERVCOPY, {
  "centralId":dataReservation.item.confirm,
    "profileType": profile.profileType
}, {
     withCredentials: true,
       credentials: 'include',
    headers: {'Authorization': 'Bearer ' + this.ls.get('Token').data,
                'Content-Type' : 'application/json',
                'Accept-Language' : this.ls.get('Language').data
                }
       })
.then(resp => {
              if (resp.status == 200 || resp.status == 201) {
                var copyReservation = {
                  infoHotel: response.data,
                  infoTarifa: resp.data
                }
                var BR = ""
                if(response.data.benefitsAndRestrictions != null) {
                  BR =  response.data.benefitsAndRestrictions
                }
                var ROS = []
                if(response.data.rateMandatorySupplementResponseList != null) {
                  ROS = response.data.rateMandatorySupplementResponseList
                }
                this.ls.set('CopyReservation', {data: copyReservation})
this.ls.set('nuitsPourS', copyReservation.infoHotel.nights)

                // GET DATA FROM AVAILIBILITY

                     var priceWS = resp.data.response.totalRateWithTaxes
                    var nightsWS = resp.data.response.nights
                    var negotiatedRatesDetailPrice = resp.data.response
                    var tabWS = resp.data.response.rateType


                // GET DATA FROM AVAILIBILITY

                var hotel = {
                  title: response.data.hotelName,
                  desc: response.data.hotelDetailResponse.hotelDescription,
                  price: priceWS,   // GET FROM AVAI DONE
                  img: response.data.hotelDetailResponse.hotelMainImage,
                  elipse: true,
                  roomCode: response.data.roomCode,
                  nights:  nightsWS,  // GET FROM AVAI  DONE
                  negotiatedRatesDetailPrice: negotiatedRatesDetailPrice,         // GET FROM AVAI  DONE

                  benefitsRestrictions: BR

                }

                  if (tabWS == "Tarifa Negociada" || tabWS == "Negotiated Rate") {

        var tWS = 1
      }
      if (tabWS == "Tarifa Publica" || tabWS == "Public Rate") {
        var tWS = 2
      }


                var datosHabHot = {
                  habitacion: data1,
                  hotel: hotel,
                  politicas: politicas,
                  hotelName: response.data.hotelName,
                  localStor: 'datosHabHotSelected',
                  countryDir: hotelCountry,
                  cityDir: hotelCity,
                  userClientID: this.ls.get('ClientId').data,
                  tabActive: tWS,
                  mojito: response.data.hotelDetailResponse.mojito,
                  specialMessage: response.data.hotelDetailResponse.specialMessage
                }

                     GlobalServices._consultaPoliticasTarifas(this.ls.get('Token').data, this.ls.get('Language').data, bodyRatePolicy).then(responseP => {
        if (responseP.status === 200) {
          datosHabHot.politicas.listPoliticas = responseP.data.ratePolicyElementResponseList;
          datosHabHot.politicas.privacyPolicyURL = responseP.data.privacyPolicyURL;
                    this.ls.set('fromCopy', true);

          this.ls.set('datosHabHotSelected', {data: datosHabHot});
               this.ls.set('availibilityRequest', {data: data1});
      this.ls.set("isCopy", true)
      this.ls.set("updateCostDetail", {data: datosHabHot})
                  this.enableLoader = false

if (response.data.hotelDetailResponse.specialMessage.length != 0) {
    this.titleConsiEspecial = (response.data.hotelDetailResponse.mojito?i18n.t('language.posadasCorporate.modales.EspecificacionesEspecialesCuba.title'):i18n.t('language.posadasCorporate.reservacionesRegistro.modalTitleConsiEspe'))
    if (response.data.hotelDetailResponse.mojito) {
      this.mojito = response.data.hotelDetailResponse.mojito;
      this.bodyConsiEspecial = response.data.hotelDetailResponse.specialMessage[0].split('.');
    } else{
      this.bodyConsiEspecial = response.data.hotelDetailResponse.specialMessage[0];
    }
    this.isModalConsiEspecial = true;
    this.direccionConsiEspe = 'copia';
  } else {
        this.$store.commit('changePersistRegistryData', true)
    this.$router.push({ name: "ReservacionesRegistro" });
  }

        }
      }).catch(error => {
        this.enableLoader = false
// Error server
    if(error.response == null) {
        if(error.message == "Error while querying rate policies" || error.message == "Error al consultar politicas de tarifa") {
              this.$router.push({ name: "Error" });
        }
    }
      else if(error.response.status == 404 ||  error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
             this.$router.push({ name: "Error" });
           }
     // Error server
      if (error.status === 401) {

          //token caduco
        }

      });
              }
         })
    .catch(error=>{
      // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
         this.enableLoader = false
                var n = error.response.data.message.indexOf("\n\n")
      this.paragraph1 = error.response.data.message.substring(0,n)
      this.paragraph2 = error.response.data.message.substring(n+1)
       if( error.response.status == 404 && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_01')  {  // && error.response.data.errorCode == 'RSP_HOTEL_AVAIL_01'
        this.isModalNoTarifas = true
        // Reset form
        this.search = ''
 this.codeHotel = ''
this.entrada = ''
 this.salida = ''
 this.adultos = 1
 this.menores = 0
 this.infantes = 0
this.habitaciones = 1
 this.agreementCode = ''
 this.iata = ''
 this.motiva = ''
this.descuento = ''
 this.promocion = ''
this.roomCodesListings = []
 var picked = ''
      if(this.$store.getters.gettingLang == 'es') {
         picked = 'MXN'
} else {
         picked = 'USD'
        }
      // Reservaciones
      var availibilityRequest = {

    hotelName: '',
      hotelCode: '',
	arrivalDate: '',
	departureDate: '',
currencyCode: picked,
	totalAdults: 1,
	totalChildren: 0,
	totalInfants: 0,
	totalRooms: 1,
	agreementCode: '',
	iataCode: '',
	motivaCode: '',
	discountCode: '',
	promoCode: '',
	profileType: '',
  roomCodeList: [],
  selectedRooms: [],
  beautiDateInput:   '',
    beautiDateOutput:   ''
  }
         var ls = new SecureLS({encodingType: 'aes'});
  ls.set('availibilityRequest', {data: availibilityRequest});
      }
})


          }
        }).catch(error => {
          this.enableLoader = false
        });
      },
    sendNoCon(row,rowValue) {
        this.ls.set("noConForRm", row.item.confirm)
    },
    settingSuppl(resObject) {
// Deeper
this.ls.set('generalUp', true)
var toS = 0
var toIm = 0
for(var i=0; i < resObject.data.response.rateOptionalSupplementResponseList.length; i++) {
    toS += resObject.data.response.rateOptionalSupplementResponseList[i].amount
    for(var j = 0; j < resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList.length; j++) {
            if(resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                toIm += resObject.data.response.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxAmount

            }}
}
this.ls.set('generalSuppl', toS)
this.ls.set('generalSupplIm', toIm)

var extraSupE = 0
var extraSupIE = 0
var extraToSE = 0 

var extraSupEFirstNight = 0
var extraSupIEFirstNight = 0
var extraToSEFirstNight = 0 
var ob = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
 var ob2 = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', ob2)
       
        this.ls.set('supleCondi', ob)
        

if(resObject.data.response.numberOfNights != null && resObject.data.response.numberOfNights != "") {

    var numNuits = resObject.data.response.numberOfNights
} else {
    var numNuits = 1
}
if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0) {
var suplObject = resObject.data.response.rateOptionalSupplementResponseList
for(var i=0; i < suplObject.length; i++) {
switch(suplObject[i].quantityType) {
    case 5:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        break;


        
        
    case 6: case 1:  case 7:  // type 6 must be
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;


    case 3:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;
        
    case 8:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
        case 2: case 6:
        extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
        
            break;

        case 4:
                 extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        
    default:
        break;
} 

}
}

    },
    updateDetailCosts(resObject) {
      this.componentKey += 1;
      if(resObject.data.response.rateOptionalSupplementResponseList != null && resObject.data.response.rateOptionalSupplementResponseList.length != 0 && resObject.data.response.rateOptionalSupplementResponseList.length != "") {

        this.settingSuppl(resObject)
      }
      var availibilityRequest = {
        totalRooms:   resObject.data.response.totalRooms,
        currencyCode:  resObject.data.response.currencyCode,
        beautiDateOutput: resObject.data.response.departureDate,
        beautiDateInput: resObject.data.response.arrivalDate

      }
      this.datosHabHotModalCosto.localStor = "datosHabHotSelected";
      this.datosHabHotModalCosto.hotel =     {

        benefitsRestrictions:  resObject.data.response.hotelDetailResponse.ratePolicyInfoResponseList[0],
        negotiatedRatesDetailPrice: {
        averageRatePerNight: resObject.data.response.ratesResponse.averageCostPerNight,
        nights: resObject.data.response.numberOfNights,
        rateType: resObject.data.response.roomContractTypeName,
        ratesDetailResponses: resObject.data.response.ratesResponse.ratesDetailResponseList,
        subTotalRateTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalRateWithTaxes:resObject.data.response.ratesResponse.totalCost,
        totalRateWithoutTaxes: resObject.data.response.ratesResponse.totalCostWithoutTaxes,
        totalSupplement: resObject.data.response.ratesResponse.totalSupplements,
        totalTaxes: resObject.data.response.ratesResponse.totalTaxesWithSupplements
        },
        nights: resObject.data.response.numberOfNights,

      }



      this.datosHabHotModalCosto.userClientID = this.ls.get('ClientId').data;


      if (resObject.data.response.roomContractTypeName == "Tarifa Negociada" || resObject.data.response.roomContractTypeName == "Negotiated Rate") {
        this.datosHabHotModalCosto.whichRates = "Negociadas";
        this.datosHabHotModalCosto.tabActive = 1
      }
      if (resObject.data.response.roomContractTypeName == "Tarifa Pública" || resObject.data.response.roomContractTypeName == "Public Rate") {
        this.datosHabHotModalCosto.whichRates = "Publicas";
        this.datosHabHotModalCosto.tabActive = 2
      }
      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Public Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Pública";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Pública"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Public Rate";
      }

      if (
        this.$store.getters.gettingLang == "es" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Negotiated Rate"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Tarifa Negociada";
      }
      if (
        this.$store.getters.gettingLang == "en" &&
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType ==
          "Tarifa Negociada"
      ) {
        this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType =
          "Negotiated Rate";
      }

      this.datosHabHotModalCosto.habitacion = availibilityRequest;
     this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.totalCostWithoutTaxesWihtSupplements = resObject.data.response.ratesResponse.totalCostWithoutTaxes//WihtSupplements
      this.ls.set("updateCostDetail", { data: this.datosHabHotModalCosto }); // TEST
      this.banDetCost = true;
if(this.flagE == false) {
  setTimeout(() => {
         this.$bvModal.show('detalleDeCosto1');
       }, 20);
} else {

  if (resObject.data.response.hotelDetailResponse.specialMessage.length != 0) {
    this.titleConsiEspecial = (resObject.data.response.hotelDetailResponse.mojito?i18n.t('language.posadasCorporate.modales.EspecificacionesEspecialesCuba.title'):i18n.t('language.posadasCorporate.reservacionesRegistro.modalTitleConsiEspe'))
    if (resObject.data.response.hotelDetailResponse.mojito) {
      this.mojito = resObject.data.response.hotelDetailResponse.mojito;
      this.bodyConsiEspecial = resObject.data.response.hotelDetailResponse.specialMessage[0].split('.');
    } else{
      this.bodyConsiEspecial = resObject.data.response.hotelDetailResponse.specialMessage[0];
    }
    this.isModalConsiEspecial = true;
    this.direccionConsiEspe = 'modificacion';
  } else {
    this.$router.push({ name: "ReservacionesModificacion" });
  }

}
      

    },
    closeExpiredModal() {
      this.isExpiredModalVisible = false;
      var ls = new SecureLS({ encodingType: "aes" });
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true;
    },
    callReservationByCode(numConfir) {
      var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_CODE,
          {
            confirmationNumber: numConfir,
            profileType: this.ls.get("Profile").data.profileType,
            hasEditCancelPermissions: this.ls.get("editCancelPermissions"),
            fullReservationData: true
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + token,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          if (res.data.response.roomContractTypeName == "Tarifa Negociada" || res.data.response.roomContractTypeName == "Negotiated Rate") {
            this.tipoTarifa = 1
          }
          if (res.data.response.roomContractTypeName == "Tarifa Pública" || res.data.response.roomContractTypeName == "Public Rate") {
            this.tipoTarifa = 2
          }
            this.ls.set('HotelDetailData', {data: res});
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            this.ls.set("codeReservation", { data: resObject });
            var guest1 = resObject.data.response.name
          

            if(resObject.data.response.fatherSurname != null) {
               guest1 = guest1.concat(" "+resObject.data.response.fatherSurname)
               if(resObject.data.response.motherSurname != null) {
                 guest1 = guest1.concat(" "+resObject.data.response.motherSurname)
               }
            }
            if(resObject.data.response.companionName != null) {

              var colleague1 = resObject.data.response.companionName
              if(resObject.data.response.companionFatherSurname != null) {
               colleague1 = colleague1.concat(" "+resObject.data.response.companionFatherSurname)
               if(resObject.data.response.companionMotherSurname != null) {
                 colleague1 = colleague1.concat(" "+resObject.data.response.companionMotherSurname)
               }
            }
            }
            var extraDetailCost = {
              noSCon: resObject.data.response.reservationNumber,
              guestName: guest1,
              colleague: colleague1,
              hotelName: resObject.data.response.hotelName,
              requirementS: resObject.data.response.requirementTypeResponse

            }
            this.ls.set("extraDetailS", extraDetailCost)
            if( this.allowDetailCost  ) {
              this.updateDetailCosts(resObject);
            } else {
              this.getPoliticasTarifas(this.ls.get("codeReservation").data.data.response)
            }
          } 
        })
        .catch(error => {
           this.allowDetailCost = true // Allow detailCost
      this.banLoaderReenvioConfirmacion = false
             let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  
  this.$router.push({ name: "Error" });
  
 
} 
// Error server 
 
          // Error server
          if (
            error.response.status == 404 &&
            error.response.data.errorCode == "RSP_RESERV_SEARCH_CODE_02"
          ) {
            this.noResultsBody = error.response.data.message;
            this.noResults = true;
          }
          if (
            error.response.status == 404 &&
            error.response.data.errorCode == "RSP_RESERV_SEARCH_CODE_01"
          ) {
            //  this.noCoincidences();
          }
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } 
        });
    },
    dataTable() {
       this.enableLoader= true
      var _this = this;
      var permissions = this.ls.get("editCancelPermissions");
      var a = "";
      a = this.ls.get("Token");
      var token = a.data.substr(1);
      axios.get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_DAYMOV,
          {
            params: {
              editCancelPermissions: permissions
            },
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
              "Accept-language": this.ls.get("Language").data
            }
          }
        )
        .then(response => {
          this.enableLoader= false
          var data = [],
            respuesta = response.data.response;
            for (var i = 0; i < respuesta.length; i++) {
              if(respuesta[i].motherSurname == null) {
                respuesta[i].motherSurname = ""
              }
            }
            for (var i = 0; i < respuesta.length; i++) {
              if(respuesta[i].fatherSurname == null) {
                respuesta[i].fatherSurname = ""
              }
            }

          Object.keys(respuesta).forEach(key =>
            data.push({
              confirm: respuesta[key].reservationNumber,
              status: respuesta[key].reservationStatus,
              name: respuesta[key].name.concat(" "+respuesta[key].fatherSurname).concat(" "+respuesta[key].motherSurname),
              hotel: respuesta[key].hotelName,
              into: respuesta[key].arrivalDate,
              out: respuesta[key].departureDate,
              options: {
                deleting: respuesta[key].showCancelReservation,
                sending: respuesta[key].showSendProform,
                emailing: respuesta[key].showSendConfirmationEmail,
                copying: respuesta[key].showCopyReservation,
                editing: respuesta[key].showModifyReservation
              }
            })
          );
          _this.items = data;
        })
        .catch(error => {
             let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 404 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
} 
// Error server 
          if (error.response.status === 404 && error.response.data.errorCode == "RSP_HOTEL_RESERV_DAILY_01") {
            this.enableLoader= false
            _this.items = [];
          } else if(error.response.status === 404 && error.response.data.errorCode != "RSP_HOTEL_RESERV_DAILY_01"){
                     this.$router.push({ name: "Error" });
          }
        });
    },
    showModalConfirmacion() {
      this.isModalConfirmacion = true;
    },
    closeModalConfirmacion() {
      this.limpiarForm();
      this.isModalConfirmacion = false;
    },
    showModalProforma() {
      this.isModalProforma = true;
    },
    closeModalProforma() {
      this.isModalProforma = false;
      this.limpiarForm();
    },
    modalorma(data){
      this.dataEnviarEmailProforma = data;

      this.banModalReenvioProforma = true;
      setTimeout(() => {
        this.$bvModal.show('reenviarProforma');
      }, 1);
    },
    sendEmailProforma(){
      this.banLoaderReenvioProforma =  true;
      const profile = this.ls.get('Profile').data;
      var listTemCorreos = [];
      if (this.emailProformaUno !== '') {
        listTemCorreos.push(this.emailProformaUno);
      }
      if (this.emailProformaDos !== '') {
        listTemCorreos.push(this.emailProformaDos);
      }
      if (this.emailProformaTres !== '') {
        listTemCorreos.push(this.emailProformaTres);
      }

      var data = {
      	reservationId: this.dataEnviarEmailProforma.confirm,
        hotelName: this.dataEnviarEmailProforma.hotel,
        checkIn: this.dataEnviarEmailProforma.into,
        checkOut: this.dataEnviarEmailProforma.out,
        guest: this.dataEnviarEmailProforma.name,
        showRates: profile.ratesPermissionsResponse.showRates,
        showPublicRates: profile.ratesPermissionsResponse.showPublicRates,
        emails: listTemCorreos
      }
      GlobalServices._enviarEmailProforma(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
        if (response.status === 200) {
          this.textModalExito = response.message;
          this.banLoaderReenvioProforma = false;

          this.$bvModal.hide('reenviarProforma');
          this.banModalReenvioProforma = false;
          setTimeout(() => {
            this.showModalProforma();
          }, 1);
        } else {
          this.$router.push({ name: "Error" });
        }
      }).catch(error => {

        this.banLoaderReenvioProforma = false;
        if (error.status == 401) {
          this.sesionClose();
        } 
           let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
  
 
}
      });

    },
    modalReenvioReservacion(data){
      this.dataReenviarConfirmacionReservacion = data;
      this.banModalReenvioConfirmacion = true;
    },
    sendRightEmail() {
      if(this.reservationStatus == "Cancelled" || this.reservationStatus  == "Cancelación") {
        this.speSpa = true
        this.sendCancelEmail()
      } else {
        this.speSpa = false
        this.sendEmailConfirmacion()
      }
    },  
    sendCancelEmail() {
      this.banLoaderReenvioConfirmacion = true
      this.allowDetailCost = false 
      this.callReservationByCode(this.cancelCode)
    },
    sendEmailConfirmacion(){
      this.banLoaderReenvioConfirmacion =  true;
      const profile = this.ls.get('Profile').data;
      var listTemCorreos = [];
      if (this.emailConfirmacionUno !== '') {
        listTemCorreos.push(this.emailConfirmacionUno);
      }
      if (this.emailConfirmacionDos !== '') {
        listTemCorreos.push(this.emailConfirmacionDos);
      }
      if (this.emailConfirmacionTres !== '') {
        listTemCorreos.push(this.emailConfirmacionTres);
      }
      var data =  {
        confirmationNumber: this.dataReenviarConfirmacionReservacion.confirm,
        profileType: profile.profileType,
        emailList: listTemCorreos
      }
      GlobalServices._enviarEmailReservacion(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
        if (response.status === 200) {
          this.textModalExitoEnvioEmail = response.message;
          this.banLoaderReenvioConfirmacion = false;

          this.banModalReenvioConfirmacion = false;
          setTimeout(() => {
            this.showModalConfirmacion();
          }, 1);
        } else {
          this.$router.push({ name: "Error" });
        }
      }).catch(error => {
        this.banLoaderReenvioConfirmacion = false;
        if (error.status == 401) {
          this.sesionClose();
        }    let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error" });
  
 
} 
// Error server 
 
      });
    },
    sesionClose(){
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: 'Login'})
    },
    cancelSendEmailProforma(){
      this.limpiarForm();
      this.$bvModal.hide('reenviarProforma')
    },
    cancelSendEmailConfirmacion(){
      this.limpiarForm();
      this.banModalReenvioConfirmacion = false;
    },
    limpiarForm(){
      this.emailProformaUno = '';
      this.emailProformaDos = '';
      this.emailProformaTres = '';
      this.emailConfirmacionUno = '';
      this.emailConfirmacionDos = '';
      this.emailConfirmacionTres = '';
    },
  }
};
</script>

<style lang="scss" scoped>
.padding-custom {
  padding-top: 115px;
  padding-bottom: 80px;
}
</style>
